var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoEntryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#1F1F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 31.5L15.7 28.3L12.1 27.5L12.45 23.8L10 21L12.45 18.2L12.1 14.5L15.7 13.7L17.6 10.5L21 11.95L24.4 10.5L26.3 13.7L29.9 14.5L29.55 18.2L32 21L29.55 23.8L29.9 27.5L26.3 28.3L24.4 31.5L21 30.05L17.6 31.5ZM21 26C21.2833 26 21.521 25.904 21.713 25.712C21.905 25.52 22.0007 25.2827 22 25C22 24.7167 21.904 24.479 21.712 24.287C21.52 24.095 21.2827 23.9993 21 24C20.7167 24 20.479 24.096 20.287 24.288C20.095 24.48 19.9993 24.7173 20 25C20 25.2833 20.096 25.521 20.288 25.713C20.48 25.905 20.7173 26.0007 21 26ZM20 22H22V16H20V22Z",
    fill: "#FFF5A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEntryIcon);
export default __webpack_public_path__ + "static/media/noEntryIcon.5b47cabb2615d01e4b35ada5bafeea3d.svg";
export { ForwardRef as ReactComponent };